import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RedirecionamentoComponent } from '@modulos/handoff/redirecionamento/redirecionamento.component';
import { RedirectComponent } from '@shared/components/redirect/redirect.component';
import { RotasApp, RotasGestaoVinculos } from '@shared/utils/constants/rotas.enum';

const routes: Routes = [
  {
    path: '',
    redirectTo: RotasApp.HOME,
    pathMatch: 'full',
  },
  {
    path: 'home-facelift',
    redirectTo: RotasApp.HOME,
    pathMatch: 'prefix',
  },
  {
    path: RotasApp.HOME,
    loadChildren: () => import('./modulos/home-facelift/home.module').then((m) => m.HomeModule),
  },
  {
    path: RotasApp.TRANSMISSORA,
    loadChildren: () => import('./modulos/transmissora/transmissora.module').then((m) => m.TransmissoraModule),
  },
  {
    path: 'receptora-simples',
    redirectTo: RotasApp.RECEPTORA,
    pathMatch: 'prefix',
  },
  {
    path: 'receptora-facelift',
    redirectTo: RotasApp.RECEPTORA,
    pathMatch: 'prefix',
  },
  {
    path: RotasApp.RECEPTORA,
    loadChildren: () =>
      import('./modulos/receptora-facelift/receptora-simples.module').then((m) => m.ReceptoraSimplesModule),
  },
  {
    path: RotasApp.CALLBACK,
    loadChildren: () => import('./modulos/callback/callback.module').then((m) => m.CallbackModule),
  },
  {
    path: 'receptora-confirmacao',
    component: RedirectComponent,
    data: {
      redirectTo: '/receptora/confirmacao',
    },
  },
  {
    path: 'iniciadora-confirmacao',
    component: RedirectComponent,
    data: {
      redirectTo: '/receptora/confirmacao',
    },
  },
  {
    path: RotasApp.HANDOFF,
    loadChildren: () => import('./modulos/handoff/handoff.module').then((m) => m.HandoffModule),
  },
  {
    path: 'handoff/redirecionamento',
    loadChildren: () => import('./modulos/handoff/handoff.module').then((m) => m.HandoffModule),
    component: RedirecionamentoComponent,
  },
  {
    path: RotasApp.DEPOSITO,
    loadChildren: () => import('./modulos/deposito/deposito.module').then((m) => m.DepositoModule),
  },
  {
    path: RotasApp.PAGTO_RECORRENTE,
    loadChildren: () =>
      import('./modulos/pagto-recorrente/pagto-recorrente.module').then((m) => m.PagtoRecorrenteModule),
  },
  {
    path: RotasApp.TRANSFERENCIA_INTELIGENTE,
    loadChildren: () =>
      import('./modulos/transferencia-inteligente/transferencia-inteligente.module').then(
        (m) => m.TransferenciaInteligenteModule
      ),
  },
  {
    path: RotasApp.PIX_AUTOMATICO,
    loadChildren: () => import('./modulos/pix-automatico/pix-automatico.module').then((m) => m.PixAutomaticoModule),
  },
  {
    path: RotasApp.INICIADORA_PIX_INTELIGENTE,
    loadChildren: () =>
      import('./modulos/iniciadora-pix-inteligente/iniciadora-pix-inteligente.module').then(
        (m) => m.IniciadoraPixInteligenteModule
      ),
  },
  {
    path: RotasApp.PORTABILIDADE_CREDITO,
    loadChildren: () =>
      import('./modulos/portabilidade-credito/portabilidade-credito.module').then((m) => m.PortabilidadeCreditoModule),
  },
  {
    path: RotasApp.GESTAO_VINCULOS,
    loadChildren: () => import('./modulos/gestao_vinculos/listagem/listagem.module').then((m) => m.ListagemModule),
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: false, relativeLinkResolution: 'legacy' })],
  exports: [RouterModule],
})
export class AppRoutingModule { }
